module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_L_1.efdcd6f2.mp3";